<template>
  <div class="mafco-customers">
    <div class="page-grid">
      <el-table :data="data.list" height="calc(100vh - 350px)" row-key="id">
        <el-table-column fixed v-for="(col, index) in columns" :width="col.width" :label="col.name" :prop="col.code" :key="index">
          <template slot-scope="scope">
            <span>{{scope.row[col.code]}}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :config="{pageIndexChanged, pageSizeChanged, pageNumber: searchParams.pageIndex, pageSize: searchParams.pageSize}" :total="data.total"></Pagination>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getCustomerListApi } from '@/api'
import Pagination from '@/components/Pagination.vue'
import Footer from '@/components/Footer'
export default {
  components: {
    Pagination, Footer
  },
  mounted () {
    this.search()
  },
  computed: {
    getPages () {
      let ps = (this.searchParams.pageSize || 10)
      let pages = Math.floor(this.data.total / ps)
      if ((this.data.total > ps && this.data.total % ps > 0) || pages === 0) {
        pages++
      }
      return pages
    }
  },
  data () {
    return {
      data: { list: [], total: 0 },
      searchParams: {
        pageSize: 10,
        pageIndex: 1
      },
      columns: [
        { name: '姓名', code: 'name' },
        { name: '公司', code: 'company' },
        { name: '国家', code: 'country' },
        { name: '州/省', code: 'state' },
        { name: '市', code: 'city' },
        { name: '地址', code: 'address' },
        { name: '邮政编码', code: 'postal_code' },
        { name: '电话', code: 'phone' },
        { name: '邮件', code: 'email' },
        { name: '兴趣点', code: 'interest' },
        { name: '兴趣产品', code: 'product_name' },
        { name: '备注', code: 'remark' }
      ]
    }
  },
  methods: {
    // 查询数据
    async search (pageIndex = this.searchParams.pageIndex) {
      this.searchParams = { ...this.searchParams, pageIndex }
      const { data } = await getCustomerListApi(this.searchParams)
      if (data.status === 200) {
        this.data = data.data
      }
    },
    pageSizeChanged (ps) {
      this.searchParams.pageSize = ps
      this.search(1)
    },
    pageIndexChanged (pn) {
      this.searchParams.pageIndex = pn
      this.search()
    }
  }
}
</script>
<style scoped lang="scss">
.mafco-customers {
  margin: 150px 100px;
  height: 450px;
  ::v-deep .mafco-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 100px;
    width: 100vw;
  }
}
</style>
